import { gql } from '@apollo/client';

export const DOWNLOAD_SEQUENCES_BATCH = gql`
  mutation DownloadSequencesBatch($sequenceIds: [String]!) {
    downloadSequencesBatch(sequenceIds: $sequenceIds) {
      success
      error
    }
  }
`;
